import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'up-footer',
  templateUrl: './footer.component.html',
  styleUrls: []
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
